import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Installation } from './alarm.model';

@Injectable({
  providedIn: 'root',
})
export class AlarmsService {
  url: string = `${environment.api_url}`;
  constructor(private http: HttpClient) {}

  getInstallations() {
    return this.http.get<any>(`${this.url}/v1/installation/dashboard`).pipe(
      catchError((error) => {
        console.error('Error fetching alarms:', error);
        return throwError(() => error);
      })
    );
  }

  getActiveAlarms() {
    return this.http
      .get<any>(
        `${this.url}/v1/alarms_list/30/3,5,11,12,14,17,18,19,22,23,24,27,33,36,37,40,41,42,43,44`
      )
      .pipe(
        catchError((error) => {
          console.log('Error recibido:', error);
          return throwError(() => error);
        })
      );
  }

  addAlarmIncident(body: any) {
    return this.http.post<any>(`${this.url}/v1/alarms/addincident/`, body).pipe(
      catchError((error) => {
        console.log('Error recibido:', error);
        return throwError(() => error);
      })
    );
  }

  addAlarmSilence(body: any) {
    return this.http.post<any>(`${this.url}/v1/alarms/silence/`, body).pipe(
      catchError((error) => {
        console.log('Error recibido:', error);
        return throwError(() => error);
      })
    );
  }

  addAlarmMaintenance(body: any) {
    return this.http
      .post<any>('http://apiv2.connect24:5000/v1/alarms/maintenance/', body)
      .pipe(
        catchError((error) => {
          console.log('Error recibido:', error);
          return throwError(() => error);
        })
      );
  }

  removeAlarmStatus(paramsReq: any) {
    const params = new HttpParams()
      .set('install_id', paramsReq.installation_id)
      .set('alarm_id', paramsReq.alarm_id)
      .set('column_value', paramsReq.alarm)
      .set('table_value', paramsReq.table)
      .set('user_id', paramsReq.user_id);
    return this.http
      .get<any>('http://apiv2.connect24:5000/v1/alarms/removeall', { params })
      .pipe(
        catchError((error) => {
          console.log('Error recibido:', error);
          return throwError(() => error);
        })
      );
  }

  getAlarmReceived(paramsReq: any) {
    const params = new HttpParams()
      .set('alarm_id', paramsReq.alarm_id)
      .set('user_id', paramsReq.user_id);

    return this.http
      .get<any>('http://apiv2.connect24:5000/v1/alarms/received', { params })
      .pipe(
        catchError((error) => {
          console.log('Error recibido:', error);
          return throwError(() => error);
        })
      );
  }
}
